// 弹出框图片类型

// 地址超出范围
export const ImgAddressOverArea = Symbol("ImgAddressOverArea");

// 外卖绑定手机号
export const ImgPackageBindPhone = Symbol("ImgPackageBindPhone");
// 堂食绑定手机号
export const ImgCanteenBindPhone = Symbol("ImgCanteenBindPhone");

// 清空购物车
export const ImgClearCart = Symbol("ImgClearCart");

// 门店状态
export const CanteenError = Symbol("CanteenError");
export const ImageMap = {
	[ImgAddressOverArea]: require("@/assets/images/messageBox/address_over_area.png"),
	[ImgPackageBindPhone]: require("@/assets/images/messageBox/package_bind_phone.png"),
	[ImgCanteenBindPhone]: require("@/assets/images/messageBox/canteen_bind_phone.png"),
	[ImgClearCart]: require("@/assets/images/messageBox/canteen_bind_phone.png"),
	[CanteenError]: require("@/assets/images/messageBox/canteen_bind_phone.png")
};
